export default function PurposeScopeIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#FFDCF3" />
      <path
        d="M13.0671 18.0501L16.7072 15.9484C17.0958 15.7241 17.2897 15.6119 17.431 15.4549C17.5561 15.3161 17.6506 15.1525 17.7083 14.9748C17.7735 14.7744 17.7735 14.5505 17.7735 14.1039V9.89447C17.7735 9.44786 17.7735 9.22398 17.7083 9.0236C17.6506 8.8459 17.5561 8.6822 17.431 8.54335C17.2903 8.38709 17.0969 8.27538 16.7116 8.05297L13.0664 5.94841C12.6778 5.72406 12.4839 5.6121 12.2773 5.5682C12.0946 5.52935 11.9056 5.52935 11.7229 5.5682C11.5163 5.61211 11.3217 5.72406 10.9331 5.94841L7.29229 8.05046C6.90416 8.27454 6.71024 8.3865 6.56902 8.54335C6.44398 8.6822 6.34956 8.8459 6.29182 9.0236C6.22656 9.22445 6.22656 9.44892 6.22656 9.89763V14.1009C6.22656 14.5496 6.22656 14.7739 6.29182 14.9748C6.34956 15.1525 6.44398 15.3161 6.56902 15.4549C6.71032 15.6119 6.90438 15.7241 7.29297 15.9484L10.9331 18.0501C11.3217 18.2744 11.5163 18.3864 11.7229 18.4303C11.9056 18.4691 12.0946 18.4691 12.2773 18.4303C12.4839 18.3864 12.6785 18.2744 13.0671 18.0501Z"
        stroke="#F31DED"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 11.9991C10 13.1036 10.8954 13.9991 12 13.9991C13.1046 13.9991 14 13.1036 14 11.9991C14 10.8945 13.1046 9.99902 12 9.99902C10.8954 9.99902 10 10.8945 10 11.9991Z"
        stroke="#F31DED"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
